"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const PT = __importStar(require("prop-types"));
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const nav_frontend_js_utils_1 = require("nav-frontend-js-utils");
const skjemaelement_feilmelding_1 = __importDefault(require("./skjemaelement-feilmelding"));
const _1 = require(".");
require("nav-frontend-skjema-style");
const cls = (className) => (0, classnames_1.default)("skjemaelement", className);
const inputCls = (harFeil) => (0, classnames_1.default)("skjemaelement__input checkboks", {
    "skjemaelement__input--harFeil": harFeil,
});
/**
 * Checkbox
 */
class Checkbox extends React.Component {
    render() {
        const _a = this.props, { className, label, id, feil, checkboxRef, disabled } = _a, other = __rest(_a, ["className", "label", "id", "feil", "checkboxRef", "disabled"]);
        const inputId = id || (0, nav_frontend_js_utils_1.guid)();
        // tslint:disable:react-a11y-role-has-required-aria-props
        return (React.createElement(_1.SkjemaGruppeFeilContext.Consumer, null, (context) => {
            const feilmelding = !!disabled ? undefined : context.feil || feil;
            // eslint-disable-next-line no-shadow
            const feilmeldingId = context.feilmeldingId || (0, nav_frontend_js_utils_1.guid)();
            return (React.createElement("div", { className: cls(className) },
                React.createElement("input", Object.assign({ type: "checkbox", className: inputCls(feilmelding), id: inputId, ref: checkboxRef, "aria-invalid": !!feilmelding, "aria-errormessage": feilmelding ? feilmeldingId : undefined, disabled: disabled }, other)),
                React.createElement("label", { className: "skjemaelement__label", htmlFor: inputId }, label),
                !context.feil && !!feil && !disabled && (React.createElement(skjemaelement_feilmelding_1.default, { id: feilmeldingId }, typeof feilmelding !== "boolean" && feilmelding))));
        }));
    }
}
exports.Checkbox = Checkbox;
Checkbox.propTypes = {
    /**
     * ClassName
     */
    className: PT.string,
    /**
     * Label for checkbox
     */
    label: PT.node.isRequired,
    /**
     * Id for checkbox, hvis id ikke er satt brukes en tilfeldig guid
     */
    id: PT.string,
    /**
     * Hvis skjemaet har feil sender man inn et objekt med en feilmelding
     */
    feil: PT.oneOfType([PT.node, PT.bool]),
    /**
     * Referanse til selve checkboxen. Brukes for eksempel til å sette fokus
     */
    checkboxRef: PT.func,
};
Checkbox.defaultProps = {
    className: undefined,
    id: undefined,
    feil: undefined,
    checkboxRef: undefined,
};
exports.default = Checkbox;
